import styled from "styled-components";

export const StyledModalSuccess = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 1.5rem;
  margin-top: 2rem;
  text-align: start;
`;